"use client";

import { useMemo, useState } from "react";

import { useJourneyData } from "@/hooks/use-journey-data";
import type { Property, SavedProperty } from "@/schemas/property";

import { AddPropertyComponent } from "@/components/app/properties/add-property-component";
import { PropertyGrid } from "@/components/app/properties/property-grid";
// App Components
import { PropertySheet } from "@/components/app/properties/property-sheet";

export function PropertyEvaluation() {
  const { savedProperties } = useJourneyData();
  const [selectedProperty, setSelectedProperty] = useState<{
    property: Property;
    savedPropertyId: string;
  } | null>(null);

  // Derive properties from savedProperties more safely
  const properties = useMemo(() => {
    if (!savedProperties?.length) return [];

    return savedProperties
      .filter(
        (sp): sp is SavedProperty & { property: Property } =>
          sp &&
          sp.property !== null &&
          !("success" in sp) &&
          typeof sp.property === "object" &&
          "id" in sp.property,
      )
      .map((sp) => sp.property);
  }, [savedProperties]);

  return (
    <div className="space-y-8">
      <div className="text-center space-y-2">
        <h3 className="text-lg font-semibold text-gray-900">
          Add properties to evaluate
        </h3>
        <p className="text-sm text-gray-600">
          Paste a listing URL from any of our supported platforms
        </p>
      </div>
      <AddPropertyComponent />
      <PropertyGrid savedItems variant="compact" />
      <PropertySheet
        property={selectedProperty?.property ?? null}
        savedPropertyId={selectedProperty?.savedPropertyId}
        onClose={() => setSelectedProperty(null)}
      />
    </div>
  );
}
